import { Outlet } from 'react-router';
import { useIsDesktop } from '../../hooks/use-is-desktop';
import { Screen } from '../app/app';
import { MobileNav } from '../mobile-nav';
import { Nav } from '../nav';

export function AppShell(): JSX.Element {
  const isDesktop = useIsDesktop();

  return (
    <>
      {isDesktop && <Nav />}
      {!isDesktop && <MobileNav />}
      <Screen>
        <Outlet />
      </Screen>
    </>
  );
}
